import React, { type FunctionComponent } from 'react'
import { type GroupedSeriesData } from 'legacy/components/DataViz/dataViz.types'
import { generateLinearGradient } from 'legacy/dash-components/line-chart-2/utils'

interface Props {
  data: Pick<GroupedSeriesData, 'type'>[]
}

export const LineChartGradient: FunctionComponent<Props> = ({ data }) => (
  <svg height="0" width="0">
    <defs>{data.map(generateLinearGradient)}</defs>
  </svg>
)
